import { Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectUserHasEitherPermissions, selectUserHasPermission } from '@core/stores/auth/auth.selectors';

import { PermissionStoreModelEnum } from '@domain/permissions/permissions.enums';

import { AsyncPipeBase } from '../async-pipe-base';

@Pipe({
  name: 'hasPermission',
  pure: false,
  standalone: true,
})
export class HasPermissionPipe
  extends AsyncPipeBase<PermissionStoreModelEnum | PermissionStoreModelEnum[], [], boolean>
  implements PipeTransform
{
  readonly #store = inject(Store);
  protected readonly defaultValue = false;

  public transform$(permissions: PermissionStoreModelEnum | PermissionStoreModelEnum[]): Observable<boolean> {
    return Array.isArray(permissions)
      ? this.#store.select(selectUserHasEitherPermissions(permissions))
      : this.#store.select(selectUserHasPermission(permissions));
  }
}
